/** Minimal synchronous key/value contract implemented by every driver. */
export interface StorageDriver {
  get(key: string): string | null;
  set(key: string, value: string): void;
  remove(key: string): void;
}

/** In-memory fallback for SSR / private-mode where Web Storage throws. */
export class MemoryDriver implements StorageDriver {
  private store = new Map<string, string>();
  get(key: string) {
    return this.store.get(key) ?? null;
  }
  set(key: string, value: string) {
    this.store.set(key, value);
  }
  remove(key: string) {
    this.store.delete(key);
  }
}

function webDriver(area: () => Storage): StorageDriver {
  try {
    const s = area();
    const probe = "__astro_probe__";
    s.setItem(probe, "1");
    s.removeItem(probe);
    return {
      get: (k) => s.getItem(k),
      set: (k, v) => s.setItem(k, v),
      remove: (k) => s.removeItem(k),
    };
  } catch {
    return new MemoryDriver();
  }
}

export const localDriver = webDriver(() => window.localStorage);
export const sessionDriver = webDriver(() => window.sessionStorage);
